import { useState } from "react";
import "./login.scss";

export default function Login({ startOpen = false }) {
  let [open, setOpen] = useState(startOpen);
  let [hidden, setHidden] = useState(false);
  if (hidden) {
    return null;
  }
  return (
    <div className={"loginModal " + (open ? "open" : "")}>
      <div className="loginBox">
        Einloggen
        <input value="admin" type="text"></input>
        <input value="123123" type="password"></input>
        <button
          onClick={() => {
            setOpen(false);
            setTimeout(() => setHidden(true), 1000);
          }}
        >
          Einloggen
        </button>
      </div>
    </div>
  );
}
